import { FieldDescriptor } from '../types/modal/FieldDescriptor';
import { CostAccountingDairenCsvPreviewItem } from '../types/costAccountingDairen/CostAccountingCsvPreviewItem';

export const COST_ACCOUNTING_DAIREN_HEADER = [
  {
    label: 'PJ No',
    sortable: true,
    sortKey: 'p.project_number',
    width: '100px',
  },
  { label: 'プロジェクト名', sortable: false, sortKey: '', width: '200px' },
  {
    label: '対象期間開始日',
    sortable: true,
    sortKey: 'e.start_date',
    width: '200px',
  },
  {
    label: '対象期間終了日',
    sortable: true,
    sortKey: 'e.end_date',
    width: '200px',
  },
  { label: '工数', sortable: false, sortKey: '', width: '100px' },
  { label: '工数原価（元）', sortable: false, sortKey: '', width: '150px' },
  {
    label: '工数原価（円）（単月末日）',
    sortable: false,
    sortKey: '',
    width: '150px',
  },
  {
    label: '工数原価（円）（単月平均）',
    sortable: false,
    sortKey: '',
    width: '150px',
  },
  {
    label: '工数原価（円）（累計平均）',
    sortable: false,
    sortKey: '',
    width: '150px',
  },
];

export const COST_ACCOUNTING_DAIREN_MODAL_FIELDS: FieldDescriptor<CostAccountingDairenCsvPreviewItem>[] =
  [
    { label: '対象期間開始日', key: 'startDate', type: 'date' },
    { label: '対象期間終了日', key: 'endDate', type: 'date' },
    { label: 'プロジェクト名', key: 'projectName', type: 'text' },
  ];
